import React, { useContext } from 'react'
import { Container, Row, Col, ListGroup } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { ThemeContext } from '../components/ThemeContext.js'

const ReportsScreen = () => {
  const { theme } = useContext(ThemeContext)
  return (
    <Container style={{ color: theme.text }}>
      <Row className='my-2'>
        <Col>
          <h3>Reports</h3>
          <ListGroup variant='flush'>
            <LinkContainer to='/charts'>
              <ListGroup.Item action>Daily Total Spend</ListGroup.Item>
            </LinkContainer>
          </ListGroup>
        </Col>
      </Row>
    </Container>
  )
}

export default ReportsScreen
